import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
//@ts-ignore
import FooterLogo from "../../assets/footerLogo.svg"
//@ts-ignore
import FacebookLogo from "../../assets/facebook.svg"
//@ts-ignore
import TwitterLogo from "../../assets/twitter.svg"
//@ts-ignore
import InstagramLogo from "../../assets/instagram.svg"

const FooterStyles = styled.footer`
  display: flex;
  padding: 100px;
  background-color: #310542;
  align-items: flex-start;
  justify-content: center;
  @media only screen and (max-width: 950px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  @media only screen and (max-width: 450px) {
    padding: 75px;
  }
  @media only screen and (max-width: 380px) {
    padding: 50px;
  }
`

const Title = styled.div`
  display: flex;
  align-items: flex-start;
  margin-right: 50px;
  > img {
    margin-right: 22px;
  }

  .description > h2 {
    font: 700 20px/25.52px "Amasis", serif;
    color: #f9f3ec;
  }
  .description > p {
    font: italic normal 700 10.48px/1.28 "Tinos", serif;
    max-width: 225px;
    color: #c29dc1;
  }
  @media only screen and (max-width: 950px) {
    margin-bottom: 12px;
  }
  @media only screen and (max-width: 450px) {
    margin-right: 25px;
  }
`

const FooterNavWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const FooterWrapper = styled.div`
  display: flex;
  @media only screen and (max-width: 950px) {
    flex-direction: column;
  }
`

const List = styled.ul`
  display: flex;
  flex-direction: column;
  list-style-type: none;

  li {
    color: #c29dc1;
    font-family: Tinos, serif;
    font-weight: bold;
    font-style: italic;
    margin-bottom: 16px;
    padding-top: 4px;
    padding-bottom: 4px;
  }

  a {
    color: #c29dc1;
    font-family: Tinos, serif;
    font-weight: bold;
    font-style: italic;
    margin-bottom: 16px;
    padding-top: 4px;
    padding-bottom: 4px;
    text-decoration: none;
  }

  &:not(:last-child) {
    margin-right: 32px;
  }

  @media only screen and (max-width: 950px) {
    margin-bottom: 8px;
  }
`

const Header = styled.li`
  && {
    font-style: normal;
    color: #f9f3ec;
    font-family: Amasis, serif;
  }
`

const SocialWrapper = styled.div`
  display: flex;
  flex-direction: row;

  img {
    margin-right: 20px;
  }
`

function Footer() {
  return (
    <FooterStyles>
      <Title>
        <img src={FooterLogo} alt="" />
        <div className="description">
          <h2>
            Heights <span className="italics">Online</span>
          </h2>
          <p>
            The Official Literary and Artistic Publication and Organization of
            the Ateneo de Manila University
          </p>
        </div>
      </Title>
      <FooterNavWrapper>
        <List>
          <Header>About Us</Header>
          <li>
            <Link to="/about-us">What is Heights</Link>
          </li>
          <li>
            <Link to="/about-us">Our History</Link>
          </li>
          <li>
            <Link to="/about-us">The Executive Board</Link>
          </li>
          <li>
            <Link to="/about-us">Our Projects</Link>
          </li>
        </List>
        <List>
          <Header>Our Works</Header>
          <li>
            <Link to="/our-works-features">Features</Link>
          </li>
          <li>
            <Link to="/our-works-news">News</Link>
          </li>
          <li>
            <Link to="/our-works-opinions">Opinions</Link>
          </li>
          <li>
            <Link to="/our-works-reviews">Reviews</Link>
          </li>
        </List>
        <List>
          <Header>Our Events</Header>
          {/* <li>AHAW &amp; AHWW</li> */}
          <li>
            <Link to="/folio-page">Folio Launch</Link>
          </li>
          <li>
            <a href="https://kuwentongpambata.com/" target="_blank">
              Kuwentong Pambata
            </a>
          </li>
        </List>
        <List>
          <Header>Contribute</Header>
          <li>
            <Link to="/contribute">English Works</Link>
          </li>
          <li>
            <Link to="/contribute">Filipino Works</Link>
          </li>
          <li>
            <Link to="/contribute">Artworks</Link>
          </li>
        </List>
        <List>
          <Header>Connect with us!</Header>
          <SocialWrapper>
            <a href="https://www.facebook.com/HeightsAteneo/" target="_blank">
              <img src={FacebookLogo} alt="" />
            </a>
            <a href="https://twitter.com/HeightsAteneo" target="_blank">
              <img src={TwitterLogo} alt="" />
            </a>
            <a href="https://www.instagram.com/heightsateneo/" target="_blank">
              <img src={InstagramLogo} alt="" />
            </a>
          </SocialWrapper>
        </List>
      </FooterNavWrapper>
    </FooterStyles>
  )
}

export default Footer
